import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { useState, useEffect } from 'react';
import groupBy from 'lodash/groupBy';
import getServiceLevels from '../services/getServiceLevels';
var services = [];
var isFetching = true;
var group = '';
var userId;

function getNormalizedServices(serviceLevels, filterByUserId) {
  var groupedServices = groupBy(serviceLevels, 'account.name');

  if (filterByUserId === null) {
    groupedServices = {
      undefined: groupedServices.undefined
    };
  }

  var arr = Object.keys(groupedServices).sort(function (a, b) {
    var aLowerCased = a.toLowerCase();
    var bLowerCased = b.toLowerCase();

    if (a === 'undefined') {
      return -1;
    }

    if (b === 'undefined') {
      return 1;
    }

    if (aLowerCased > bLowerCased) {
      return 1;
    }

    if (bLowerCased > aLowerCased) {
      return -1;
    }

    return 0;
  }).reduce(function (acc, key) {
    var isUndefined = key === 'undefined';
    var fleetServiceKey = isUndefined ? 'Retail' : key;

    var newAcc = _toConsumableArray(acc);

    if (!isUndefined) {
      newAcc = newAcc.concat(['divider']);
    }

    newAcc = newAcc.concat([{
      key: fleetServiceKey,
      name: fleetServiceKey,
      label: fleetServiceKey,
      variant: 'header'
    }]);
    newAcc = newAcc.concat(groupedServices[key].map(function (serviceLevel) {
      var id = serviceLevel.id,
          name = serviceLevel.name;
      return {
        key: id,
        name: id,
        label: name,
        value: serviceLevel
      };
    }));
    return newAcc;
  }, []);
  return arr;
}

export default function useServiceLevels(_ref) {
  var app = _ref.app,
      groupId = _ref.groupId,
      filterByUserId = _ref.filterByUserId;

  var _useState = useState(services),
      _useState2 = _slicedToArray(_useState, 2),
      serviceLevels = _useState2[0],
      setServiceLevels = _useState2[1];

  var _useState3 = useState(isFetching),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var serviceLevelsResponse, normalizedServices;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(services.length === 0 || groupId !== group || userId !== filterByUserId)) {
                _context.next = 9;
                break;
              }

              _context.next = 3;
              return getServiceLevels({
                app: app,
                groupId: groupId,
                userId: filterByUserId
              });

            case 3:
              serviceLevelsResponse = _context.sent;

              if (serviceLevelsResponse && serviceLevelsResponse.data) {
                normalizedServices = getNormalizedServices(serviceLevelsResponse.data, filterByUserId);
                services = normalizedServices;
                setServiceLevels(normalizedServices);
              }

              isFetching = false;
              group = groupId;
              userId = filterByUserId;
              setLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [app, groupId, filterByUserId]);
  return [serviceLevels, isLoading];
}